import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

/** Secondary tab strip for long construction pages. sections: [{ key, label, node }] */
export function SubTabs({ sections, prefix, defaultKey }) {
  const [v, setV] = useState(defaultKey || sections[0].key);
  return <Tabs value={v} onValueChange={setV} data-testid={`${prefix}-subtabs`}>
    <TabsList className="mb-3 flex-wrap h-auto bg-secondary/60">{sections.map((s) => <TabsTrigger key={s.key} value={s.key} className="text-xs" data-testid={`${prefix}-sub-${s.key}`}>{s.label}</TabsTrigger>)}</TabsList>
    {sections.map((s) => <TabsContent key={s.key} value={s.key} className="space-y-3">{s.node}</TabsContent>)}
  </Tabs>;
}
